(function () {
  var FORM_ID = 'UZrbR9';
  var PROMO = 'EXIT10';
  var BLOCKING_PROMO = 'welcome15';
  var SESSION_KEY = 'exit_popup_shown';
  var VIEWED_PRODUCT_KEY = 'viewed_product';
  var WELCOME_APPLIED_KEY = 'welcome15_applied';
  var TIMER_EXPIRES_KEY = 'exit_offer_expires_at';
  var OFFER_DURATION_MS = 10 * 60 * 1000;
  var SCROLL_DOWN_PCT = 0.4;
  var SCROLL_UP_SPEED = 1.5;

  var path = window.location.pathname.toLowerCase();
  var search = window.location.search.toLowerCase();

  if (path.indexOf('/discount/' + BLOCKING_PROMO) === 0 || search.indexOf('discount=' + BLOCKING_PROMO) !== -1) {
    localStorage.setItem(WELCOME_APPLIED_KEY, '1');
  }

  if (path.indexOf('/products/') === 0) {
    sessionStorage.setItem(VIEWED_PRODUCT_KEY, '1');
  }

  if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;
  if (sessionStorage.getItem(SESSION_KEY)) return;
  if (localStorage.getItem(WELCOME_APPLIED_KEY)) return;

  var triggered = false;
  var cartSnapshot = null;
  var viewEventFired = false;
  var ctaClicked = false;
  var dismissEventFired = false;
  var ctaListenerAttached = false;

  function klaviyoTrack(eventName, props) {
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['track', eventName, props || {}]);
    } catch (e) { /* silent */ }
  }

  function buildTrackPayload(extra) {
    var items = (cartSnapshot && cartSnapshot.items) || [];
    var payload = {
      OfferCode: PROMO,
      DiscountPercent: 10,
      CartValue: cartSnapshot ? cartSnapshot.total_price / 100 : 0,
      Currency: cartSnapshot ? cartSnapshot.currency : 'USD',
      ItemCount: cartSnapshot ? cartSnapshot.item_count : 0,
      ProductIds: items.map(function (i) { return i.product_id; }),
      ProductTitles: items.map(function (i) { return i.product_title || i.title; }),
      Trigger: 'exit_intent',
      Placement: 'cart_abandonment',
      Device: (window.innerWidth < 768 || /Mobi|Android/i.test(navigator.userAgent)) ? 'mobile' : 'desktop'
    };
    if (extra) {
      Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
    }
    return payload;
  }

  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) {
      return '$' + amount;
    }
  }

  function openPopup() {
    if (triggered) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;

    var proceed = function (eligible) {
      if (!eligible) return;
      triggered = true;
      sessionStorage.setItem(SESSION_KEY, '1');
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', FORM_ID]);
      if (!viewEventFired) {
        viewEventFired = true;
        klaviyoTrack('Viewed Exit Offer', buildTrackPayload());
      }
    };

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartSnapshot = cart;
        var viewedProduct = sessionStorage.getItem(VIEWED_PRODUCT_KEY) === '1';
        proceed(cart.item_count > 0 || viewedProduct);
      })
      .catch(function () {
        var viewedProduct = sessionStorage.getItem(VIEWED_PRODUCT_KEY) === '1';
        if (viewedProduct) proceed(true);
      });
  }

  var isMobile = window.innerWidth < 768 || /Mobi|Android/i.test(navigator.userAgent);

  if (!isMobile) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 10) return;
      openPopup();
    });
  } else {
    var maxPct = 0;
    var lastY = window.scrollY;
    var lastT = Date.now();
    var passedThreshold = false;

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docH > 0 ? y / docH : 0;
      if (pct > maxPct) maxPct = pct;
      if (maxPct >= SCROLL_DOWN_PCT) passedThreshold = true;

      var now = Date.now();
      var dy = y - lastY;
      var dt = now - lastT;

      if (passedThreshold && dy < 0 && dt > 0) {
        var speed = Math.abs(dy) / dt;
        if (speed > SCROLL_UP_SPEED) openPopup();
      }
      lastY = y;
      lastT = now;
    }, { passive: true });
  }

  var formProcessed = false;

  function findPlaceholderNode(marker) {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf(marker) !== -1) return n;
    }
    return null;
  }

  function processFormWhenReady() {
    if (formProcessed) return;
    var hasPlaceholder = findPlaceholderNode('EXIT_OLD_PRICE') ||
                         findPlaceholderNode('EXIT_NEW_PRICE') ||
                         findPlaceholderNode('EXIT_COUNTDOWN');
    if (!hasPlaceholder) return;

    formProcessed = true;
    console.log('[exit-popup] placeholders detected, processing form');

    var expiresAt = parseInt(sessionStorage.getItem(TIMER_EXPIRES_KEY), 10);
    if (!expiresAt || isNaN(expiresAt) || expiresAt < Date.now()) {
      expiresAt = Date.now() + OFFER_DURATION_MS;
      sessionStorage.setItem(TIMER_EXPIRES_KEY, String(expiresAt));
    }

    var run = function () { renderForm(expiresAt); };
    if (!cartSnapshot) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartSnapshot = cart; run(); })
        .catch(run);
    } else {
      run();
    }
  }

  function renderForm(expiresAt) {
    (function () {
      var oldPriceText = '';
      var newPriceText = '';
      if (cartSnapshot && cartSnapshot.item_count > 0) {
        var oldAmount = cartSnapshot.total_price;
        var newAmount = Math.round(oldAmount * 0.9);
        oldPriceText = formatMoney(oldAmount, cartSnapshot.currency);
        newPriceText = formatMoney(newAmount, cartSnapshot.currency);
      } else {
        oldPriceText = '';
        newPriceText = 'Save 10%';
      }

      var hasCartPrice = cartSnapshot && cartSnapshot.item_count > 0;
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      var node;
      var countdownNode = null;
      var nodesToProcess = [];
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf('EXIT_OLD_PRICE') !== -1 ||
            node.nodeValue.indexOf('EXIT_NEW_PRICE') !== -1 ||
            node.nodeValue.indexOf('EXIT_COUNTDOWN') !== -1) {
          nodesToProcess.push(node);
        }
      }
      nodesToProcess.forEach(function (n) {
        if (n.nodeValue.indexOf('EXIT_OLD_PRICE') !== -1) {
          if (!hasCartPrice) {
            var parentBlock = n.parentElement;
            while (parentBlock && parentBlock.childNodes.length <= 3 && parentBlock.parentElement) {
              if (parentBlock.tagName === 'P' || parentBlock.tagName === 'DIV') break;
              parentBlock = parentBlock.parentElement;
            }
            if (parentBlock) parentBlock.style.display = 'none';
            return;
          }
          n.nodeValue = n.nodeValue.replace('EXIT_OLD_PRICE', oldPriceText);
        }
        if (n.nodeValue && n.nodeValue.indexOf('EXIT_NEW_PRICE') !== -1) {
          n.nodeValue = n.nodeValue.replace('EXIT_NEW_PRICE', newPriceText);
        }
        if (n.nodeValue && n.nodeValue.indexOf('EXIT_COUNTDOWN') !== -1) {
          countdownNode = n;
        }
      });

      if (!countdownNode) return;
      var span = document.createElement('span');
      span.id = 'exit-countdown';
      span.textContent = '10:00';
      var parent = countdownNode.parentNode;
      var parts = countdownNode.nodeValue.split('EXIT_COUNTDOWN');
      parent.insertBefore(document.createTextNode(parts[0]), countdownNode);
      parent.insertBefore(span, countdownNode);
      parent.insertBefore(document.createTextNode(parts[1] || ''), countdownNode);
      parent.removeChild(countdownNode);

      var countEl = span;

      var expired = false;
      var interval;

      function render() {
        var remaining = Math.max(0, expiresAt - Date.now());
        var total = Math.floor(remaining / 1000);
        var m = Math.floor(total / 60);
        var s = total % 60;
        countEl.textContent = m + ':' + (s < 10 ? '0' + s : s);
        if (remaining <= 0 && !expired) {
          expired = true;
          onExpired();
        }
      }

      function onExpired() {
        clearInterval(interval);
        countEl.textContent = 'Offer expired';
        var btn = document.querySelector('a[href*="/discount/' + PROMO + '"]');
        if (btn) {
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
          }, true);
          btn.style.opacity = '0.5';
          btn.style.pointerEvents = 'none';
          btn.textContent = 'OFFER EXPIRED';
        }
      }

      render();
      interval = setInterval(render, 1000);

      if (!ctaListenerAttached) {
        var ctaBtn = document.querySelector('a[href*="/discount/' + PROMO + '"]');
        if (ctaBtn) {
          ctaListenerAttached = true;
          ctaBtn.addEventListener('click', function () {
            if (ctaClicked) return;
            ctaClicked = true;
            klaviyoTrack('Clicked Exit Offer CTA', buildTrackPayload());
          });
        }
      }
    })();
  }

  document.addEventListener('klaviyoForms', function (e) {
    var detail = e.detail || {};
    if (detail.type !== 'close') return;
    if (detail.formId && detail.formId !== FORM_ID) return;
    if (!viewEventFired || ctaClicked || dismissEventFired) return;
    dismissEventFired = true;
    klaviyoTrack('Dismissed Exit Offer', buildTrackPayload({ DismissedAfterSeconds: null }));
  });

  setInterval(processFormWhenReady, 300);
  var mo = new MutationObserver(processFormWhenReady);
  mo.observe(document.body, { childList: true, subtree: true });
})();
